export default __webpack_public_path__ + "static/media/page404.55632895.png";